import { CustomToastComponent } from "@/components/shared";
import { CreateOrganizationsDocument, CreateOrganizationsMutation, CreateOrganizationsMutationVariables } from "@/graphql/__generated__/graphql";
import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

/**
 * Custom hook for creating organizations with nested children structure.
 * Handles the CreateOrganizations mutation with proper cache updates and error handling.
 *
 * @returns {Object} - Contains the createOrganizationsMutation function, loading state, and error state.
 */
export default function useCreateOrganizationsMutationHook(): { createOrganizationsMutation: any, loading: any, error: any } {
  const { t } = useTranslation(["toasts"]);

  const [createOrganizationsMutation, { loading, error }] = useMutation<CreateOrganizationsMutation, CreateOrganizationsMutationVariables>(
    CreateOrganizationsDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "organizations-created-success",
          data: {
            title: t("toasts.organizationscreatedsuccessfully"),
            type: "success",
          }
        });
      },
    });

  return {
    createOrganizationsMutation,
    loading,
    error
  };
}
